import * as React from 'react';

export const RightArrow: React.FC<{ fill?: string }> = ({ fill = 'white' }) => (
  <svg width="6" height="16" viewBox="0 0 6 16" fill="none">
    <path d="M0 8L6 0V16L0 8Z" fill={fill} />
  </svg>
);
